import React, { useRef } from 'react';
import api from '../config/api';

function LocationTypeList({ locationTypes, onDelete, onCreateNew, onEdit, onRefresh }) {
  const fileInputRef = useRef(null);

  const handleExport = async () => {
    try {
      const response = await api.get('/location-types/export', {
        responseType: 'blob'
      });
      
      const blob = new Blob([response.data], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `location_types_export_${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error exporting location types:', error);
      alert('Failed to export location types');
    }
  };

  const handleImport = () => {
    fileInputRef.current.click();
  };

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const text = await file.text();
      const importData = JSON.parse(text);
      
      if (importData.type !== 'location_types') {
        alert('Invalid file type. Please select a location types export file.');
        return;
      }

      const response = await api.post('/location-types/import', importData);
      
      if (response.data.success) {
        alert(`Import completed!\nImported: ${response.data.imported}\nSkipped: ${response.data.skipped}\n\nErrors:\n${response.data.errors.join('\n')}`);
        if (onRefresh) onRefresh();
      } else {
        alert('Import failed: ' + (response.data.error || 'Unknown error'));
      }
    } catch (error) {
      console.error('Error importing location types:', error);
      alert('Failed to import location types: ' + error.message);
    }
    
    // Reset file input
    event.target.value = '';
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <h2>Location Types</h2>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button className="btn btn-secondary" onClick={handleExport}>
            📥 Export
          </button>
          <button className="btn btn-secondary" onClick={handleImport}>
            📤 Import
          </button>
          <button className="btn" onClick={onCreateNew}>
            Create New Location Type
          </button>
        </div>
      </div>
      
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileSelect}
        accept=".json"
        style={{ display: 'none' }}
      />

      {locationTypes.length === 0 ? (
        <div className="card">
          <p>No location types yet. Create location types to define where your inventory items can be located!</p>
        </div>
      ) : (
        <div className="inventory-list">
          {locationTypes.map(locationType => (
            <div key={locationType.id} className="inventory-card">
              <h3>{locationType.name}</h3>
              <p><strong>Locations:</strong> {locationType.locations ? locationType.locations.length : 0}</p>
              
              {locationType.locations && locationType.locations.length > 0 && (
                <div style={{ marginTop: '1rem' }}>
                  <strong>Available locations:</strong>
                  <ul style={{ margin: '0.5rem 0', paddingLeft: '1.5rem', fontSize: '0.9rem' }}>
                    {locationType.locations.slice(0, 5).map((location, index) => (
                      <li key={index}>{location}</li>
                    ))}
                    {locationType.locations.length > 5 && (
                      <li>... and {locationType.locations.length - 5} more</li>
                    )}
                  </ul>
                </div>
              )}
              
              <div style={{ marginTop: '1rem' }}>
                <button className="btn" onClick={() => onEdit(locationType)}>
                  Edit
                </button>
                <button 
                  className="btn btn-danger" 
                  onClick={() => {
                    if (window.confirm('Are you sure you want to delete this location type?')) {
                      onDelete(locationType.id);
                    }
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LocationTypeList;